import { createSlice } from '@reduxjs/toolkit'
import { NameDto } from 'api/Common/Types'
import { IntroducingBrokerBasicDto } from 'api/Trading-Accounts/Types/IntroducingBrokerBasicDto'
import { IntroducingBrokerCalculationStatus } from 'api/Trading-Accounts/Types/IntroducingBrokerCalculationStatus'
import { IntroducingBrokerProfileAccountType } from 'api/Trading-Accounts/Types/IntroducingBrokerProfileAccountType'
import { IntroducingBrokerProfileDto } from 'api/Trading-Accounts/Types/IntroducingBrokerProfileDto'
import { IntroducingBrokerStatus } from 'api/Trading-Accounts/Types/IntroducingBrokerStatus'

const initialState: PartnershipsState = {
  bonusNvAdjustmentReasons: [],
  rebateCalcMethods: [],
  introducingBrokersByCompany: {},
  introducingBrokersCachedAtByCompany: {},
  introducingBrokersProfiles: [],
  introducingBrokerStatus: [],
  introducingBrokerCalculationStatus: [],
  introducingBrokerProfileAccountType: [],
  introducingBrokerParentTypes: [],
  ibRebatesApprovalTypes: [],
  ibRebatesPeriods: [],
}

export interface PartnershipsState {
  bonusNvAdjustmentReasons: NameDto[]
  rebateCalcMethods: NameDto[]
  introducingBrokersByCompany: Record<number, IntroducingBrokerBasicDto[]>
  introducingBrokersCachedAtByCompany: Record<number, number>
  introducingBrokersProfiles: IntroducingBrokerProfileDto[]
  introducingBrokerStatus: IntroducingBrokerStatus[]
  introducingBrokerCalculationStatus: IntroducingBrokerCalculationStatus[]
  introducingBrokerProfileAccountType: IntroducingBrokerProfileAccountType[]
  introducingBrokerParentTypes: NameDto[]
  ibRebatesApprovalTypes: NameDto[]
  ibRebatesPeriods: NameDto[]
}

export const partnershipsSlice = createSlice({
  name: 'partnerships',
  initialState,
  reducers: {
    setBonusNvAdjustmentReasons: (state, action) => {
      state.bonusNvAdjustmentReasons = action.payload
    },
    setRebateCalcMethodTypes: (state, action) => {
      state.rebateCalcMethods = action.payload
    },
    setIntroducingBrokersByTickmillCompany: (
      state,
      action: {
        payload: { tickmillCompanyId: number; data: IntroducingBrokerBasicDto[]; cachedAt: number }
      }
    ) => {
      state.introducingBrokersByCompany[action.payload.tickmillCompanyId] = action.payload.data
      state.introducingBrokersCachedAtByCompany ??= {}
      state.introducingBrokersCachedAtByCompany[action.payload.tickmillCompanyId] =
        action.payload.cachedAt
    },
    resetIntroducingBrokersByCompany: (state) => {
      state.introducingBrokersByCompany = initialState.introducingBrokersByCompany
      state.introducingBrokersCachedAtByCompany = initialState.introducingBrokersCachedAtByCompany
    },
    setIntroducingBrokersProfilesByTickmillCompany: (state, action) => {
      state.introducingBrokersProfiles = action.payload
    },
    setIntroducingBrokerStatus: (state, action) => {
      state.introducingBrokerStatus = action.payload
    },
    setIntroducingBrokerCalculationStatus: (state, action) => {
      state.introducingBrokerCalculationStatus = action.payload
    },
    setIntroducingBrokerProfileAccountType: (state, action) => {
      state.introducingBrokerProfileAccountType = action.payload
    },
    setIntroducingBrokerParentTypes: (state, action) => {
      state.introducingBrokerParentTypes = action.payload
    },
    setIBRebatesApprovalTypes: (state, action) => {
      state.ibRebatesApprovalTypes = action.payload
    },
    setIBRebatesPeriods: (state, action) => {
      state.ibRebatesPeriods = action.payload
    },
  },
})
